import type { State } from 'src/shared/core/type/reduxTypes';

export function getNotificationCount(state: State): number {
  return state.app.notifications.unreadCount;
}
